import { PascalCaseToCamelCase } from '@approvalmax/types';
import { objectHelpers } from '@approvalmax/utils';
import { backend, domain } from 'modules/data';

export function parseXeroTaxCode(
    value: backend.IntegrationsXeroTaxCode | PascalCaseToCamelCase<backend.IntegrationsXeroTaxCode>
): domain.XeroTaxCode {
    return {
        id: objectHelpers.keyOf(value, 'taxType'),
        text: `${objectHelpers.keyOf(value, 'name')} (${objectHelpers.keyOf(value, 'taxRate')}%)`,
        applicableToAccountClasses: objectHelpers.keyOf(value, 'applicableToAccountClasses') || [],
        rate: objectHelpers.keyOf(value, 'taxRate'),
        rateEffective: objectHelpers.keyOf(value, 'taxRateEffective'),
    };
}
